<template>
  <div class="full-page-width relative locations">
    <Btn class="brand off-position" :icon="{ name: 'add', size: '18', color: '#fff'}" btnText="Add Shop"
         @btnClick="openNewPopup"/>
    <div class="row">
      <div class="col-xs-4 text-box">
        <h2>Shops</h2>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          Ut consectetur nunc tincidunt venenatis tincidunt.
          Aenean consectetur iaculis posuere.
        </p>
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li class="list-table-item" v-for="(item, index) in get_shops.items" :key="`item-${index}`">
            <div class="table-cell small">
              <Icon :circle=true name="location" size="20"/>
            </div>
            <div class="table-cell">
              <p>
                <span class="main-info">{{ item.name }}</span>
                <span class="additional-info">{{ item.shop_code }}, {{ item.sender_name }}</span>
              </p>
            </div>
            <Btn
              class="button brand"
              :icon="{
                name: 'pen',
                size: '18',
                color: '#fff',
              }"
              btnText="Edit"
              @btnClick="openEditPopup(item.id)"/>
          </li>
        </ul>
      </div>
    </div>
    <Popup v-if="openPopup" @cancel="togglePopup" @confirm="submitForm">
      <template v-slot:header>
        <h2>Add shops</h2>
      </template>
      <div>
        <div class="row">
          <InputText
            class="col-xs-12"
            placeholder="Name"
            label="Name"
            v-model="form.name"/>
          <InputText
            class="col-xs-12"
            placeholder="Shop code"
            label="Shop code"
            v-model="form.shop_code"/>
          <InputSelect
            class="col-xs-12"
            label="Shipper"
            v-model="form.sender_id"
            :options="get_location_shippers"/>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>/* eslint-disable */
import {mapGetters} from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';

export default {
  name: 'Shops',
  components: {Btn, Popup, InputText, InputSelect},
  computed: {
    ...mapGetters([
      'get_shops',
      'get_shop_by_id',
      'get_location_shippers'
    ]),
  },
  data() {
    return {
      openPopup: false,
      isEdit: false,
      shopId: '',
      form: {
        name: '',
        shop_code: '',
        sender_id: ''
      },
    };
  },
  created() {
    this.$store.dispatch('GET_SHOPS');

    this.$store.dispatch('GET_OPTIONS_FOR_SELECTS_PREFERENCES');
  },
  methods: {
    clearLocalFormData() {
      this.form = {
        name: '',
        shop_code: '',
        sender_id: ''
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.shopId = '';
      this.clearLocalFormData();
    },
    submitForm() {
      const action = this.isEdit ? 'EDIT_SHOP' : 'SET_SHOP';

      this.$store.dispatch(`${action}`, {
        form: this.form,
        id: this.shopId || '',
      }).then(() => {
        this.$store.dispatch('GET_SHOPS');
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    openNewPopup() {
      this.isEdit = false;
      this.togglePopup();
    },
    openEditPopup(id) {
      this.togglePopup();
      this.isEdit = true;
      this.shopId = id;
      this.form = {...this.get_shop_by_id(id)};
    },
  },
};
</script>
